export const VALIDATE_TOKEN_SUCCESS='VALIDATE_TOKEN_SUCCESS'
export const VALIDATE_TOKEN_FAILURE='VALIDATE_TOKEN_FAILURE'
export const VALIDATE_TOKEN_REQUEST='VALIDATE_TOKEN_REQUEST'